let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9opeZ")).then(() => parcelRequire('44FvL'));